import { Redirect, Router } from "@reach/router";
import { User } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import { RouteGuard, getDefaultLink } from "./utils/helpers/role-helpers";
import Client from "./pages/client";
import Application from "./pages/application";

const getRoutes: (user: User | null) => JSX.Element = user => {
  const defaultLink = getDefaultLink(user);

  return (
    <Router>
      {user && <Redirect from="/" to={defaultLink} noThrow />}
      <Redirect
        from="/spa/automated-billing-portlet"
        to={defaultLink}
        noThrow
      />

      <NotFound default />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ABS_ADMIN"]}
        component={Client}
        path="/client"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ABS_ADMIN"]}
        component={Application}
        path="/application"
      />
    </Router>
  );
};

export default getRoutes;
